import { auth, } from '@/firebase/config'
import { signInWithEmailAndPassword } from "firebase/auth"
import { ref } from 'vue'
import store from "@/store"

const signInError = ref(null)

/**
 * Signs the user in if they checked remember me during loggin in.
 * 
 * @returns {Promise<void>}
 */
const checkLogin = async () => {
    try {
        // First we see if we have the state.
        const existingUser = store.state.user
        const existingPassword = store.state.password
        const existingRememberMe = store.state.rememberMe

        if (existingUser && existingPassword && existingRememberMe) {
            if (existingRememberMe === true) {
                await signInWithEmailAndPassword(auth, existingUser.email, existingPassword)
            }
        }
    }
    catch (err) {
        signInError.value = err.message
    }
}

const checkAutoLogin = () => {
    return { checkLogin, }
}

export default checkAutoLogin
